import { FormHelperText, Stack } from '@mui/material';
import Switch from '@mui/material/Switch';
import React from 'react';
import { InputStatus } from 'src/components/input/Input.interface';

import { WidgetsCommonProps } from '../widget.interface';
import { InputLabel, TextField, Wrapper } from './SwitchButtonWidget.styled';

export const SwitchButtonWidget = React.forwardRef(
  (props: WidgetsCommonProps, ref) => {
    const { switchValueTrue, switchValueFalse } = props.options || {};
    const inactiveTextStatus = props.disabled && InputStatus.DISABLED;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;
      if (checked) {
        props.onChange(switchValueTrue !== undefined ? switchValueTrue : true);
      } else {
        props.onChange(
          switchValueFalse !== undefined ? switchValueFalse : false,
        );
      }
    };

    return (
      <Stack gap="6px">
        <InputLabel>{props.label}</InputLabel>
        <Stack direction="row" spacing={1} alignItems="center">
          {!props.options?.noLabel && (
            <TextField status={inactiveTextStatus ? 'disabled' : 'enabled'}>
              {props.options?.leftLabel || 'Hide'}
            </TextField>
          )}
          <Switch
            checked={
              switchValueTrue !== undefined && switchValueTrue === props.value
                ? true
                : switchValueFalse !== undefined &&
                  switchValueFalse === props.value
                ? false
                : typeof props.value === 'undefined'
                ? false
                : Boolean(props.value)
            }
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
            inputRef={ref}
            data-testid={props['data-testid']}
            disabled={props.disabled}
          />
          <TextField
            status={inactiveTextStatus ? 'disabled' : 'enabled'}
            component="span">
            <TextField status={inactiveTextStatus ? 'disabled' : 'enabled'}>
              {props.options?.noLabel
                ? ''
                : props.options?.rightLabel || 'Visible'}
            </TextField>
          </TextField>
        </Stack>
        <Wrapper>
          <FormHelperText error={props.hasError}>
            {props.hasError ? props.error : undefined}
          </FormHelperText>
        </Wrapper>
      </Stack>
    );
  },
);
